import React from 'react';

import Layout from '../components/Layout';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Link } from 'gatsby';
import pic1 from '../assets/images/pic01.jpg';
import pic2 from '../assets/images/pic02.jpg';
import Scroll from '../components/Scroll';
import Gallery from '../components/Gallery';

const ROW1_IMAGES = [
  {
    src: require('../assets/images/fulls/pic01.jpeg'),
    thumbnail: require('../assets/images/fulls/pic01.jpeg'),
    caption: 'Connect Around..',
  },
  {
    src: require('../assets/images/fulls/pic02.jpeg'),
    thumbnail: require('../assets/images/fulls/pic02.jpeg'),
    caption: 'Connect with family..',
  },
  {
    src: require('../assets/images/fulls/pic03.png'),
    thumbnail: require('../assets/images/fulls/pic03.png'),
    caption: 'Stream unlimited with the Old..',
  },
  {
    src: require('../assets/images/fulls/pic04.jpeg'),
    thumbnail: require('../assets/images/fulls/pic04.jpeg'),
    caption: "Together Connected..",
  },
];



const ROW2_IMAGES = [
  {
    src: require('../assets/images/fulls/pic05.jpg'),
    thumbnail: require('../assets/images/fulls/pic05.jpg'),
    caption: 'Connect with the Abroad..',
  },
  {
    src: require('../assets/images/fulls/pic06.jpeg'),
    thumbnail: require('../assets/images/fulls/pic06.jpeg'),
    caption: 'Connect with Dream..',
  },
  {
    src: require('../assets/images/fulls/pic07.jpeg'),
    thumbnail: require('../assets/images/fulls/pic07.jpeg'),
    caption: 'Share the Connection..',
  },
  {
    src: require('../assets/images/fulls/pic08.png'),
    thumbnail: require('../assets/images/fulls/pic08.png'),
    caption: 'Ideal for Rural Connectivity..',
  },
];


const ROW3_IMAGES = [
  {
    src: require('../assets/images/fulls/pic09.jpeg'),
    thumbnail: require('../assets/images/fulls/pic09.jpeg'),
    caption: 'Get Connected Everywhere..',
  },
  {
    src: require('../assets/images/fulls/pic10.jpeg'),
    thumbnail: require('../assets/images/fulls/pic10.jpeg'),
    caption: 'Connect with Passion..',
  },
  {
    src: require('../assets/images/fulls/pic11.jpeg'),
    thumbnail: require('../assets/images/fulls/pic11.jpeg'),
    caption: 'Connect with Determination..',
  },
  {
    src: require('../assets/images/fulls/pic12.jpeg'),
    thumbnail: require('../assets/images/fulls/pic12.jpeg'),
    caption: 'Connect with Happiness..',
  },
];





const IndexPage = () => (
  <Layout>
    <Header />

    <section id="banner">
      <header>
        <h2> Linking the World..</h2>
      </header>
      <p>
       High-speed, low latency broadband internet.by{' '}
        <a href="http://sworld.netlify.app">PaaSat</a> for{' '}
        <a href="http://jclick.netlify.app"> <b> the Smartest Access</b> </a>.<br />
        of the Internet-
        <br />
        under the{' '}
        <a href="http://sworld.netlify.app">Digital Revolution</a>.
      </p>
      <footer>
        <Scroll type="id" element="first">
          <a href="http://jclick.netlify.app/" className="button style2 scrolly">
            Proceed As Anticipated.. 
          </a>  
        </Scroll>
      </footer>
    </section>

    <article id="first" className="container box style1 right">
      <a href="/#" className="image fit">
        <img src={pic1} alt="" />
      </a>
      <div className="inner">
        <header>
          <h2>
            Connetced World of..
            <br />
            Tomorrow..
          </h2>
        </header>
        <p>
          PaaSat will be delivering initial beta service both domestically and internationally, and will continue expansion to near global coverage of the populated world in 2026.
        </p>
      </div>
    </article>

    <article className="container box style1 left">
      <a href="/#" className="image fit">
        <img src={pic2} alt="" />
      </a>
      <div className="inner">
        <header>
          <h2>
            Speed.
            <br />
          Innovatively Connected.
          </h2>
        </header>

        <p>
         During beta, users can expect to see data speeds vary from 50Mb/s to 150Mb/s and latency from 20ms to 40ms in most locations over the next several months as we enhance the PaaSat system. 
         There will also be brief periods of no connectivity at all.
        </p>
        
      </div>


    </article>

    <article className="container box style2">
      <header>
        <h2>Ideal for rural + Remote communities..</h2>
        <p>
         
PaaSat is ideally suited for areas of the globe where connectivity has typically been a challenge. 

          <br />
       Unbounded by traditional ground infrastructure,  delivering high-speed broadband internet to locations where access has been unreliable or completely unavailable.
        </p>
      </header>


      <div className="inner gallery">
        <Gallery
          images={ROW3_IMAGES.map(({ src, thumbnail, caption }) => ({
            src,
            thumbnail,
            caption,
          }))}
        />
        
      </div>
    </article>

    <article className="container box style2">
      <header>
        <h2>Accelerate Innovation..</h2>
        <p>
         
As we launch more satellites , install more ground stations and improve our networking software, data speed, 

          <br />
          latency and uptime will improve dramatically.
        </p>
      </header>

      <div className="inner gallery">
        <Gallery
          images={ROW1_IMAGES.map(({ src, thumbnail, caption }) => ({
            src,
            thumbnail,
            caption,
          }))}
        />
       
      </div>
    </article>

    <article className="container box style3">
      <header>
        <h2></h2>
        <p>Paalink satellites are over 50 times closer to Earth than traditional satellites, resulting in lower latency and the ability to support services typically not possible with traditional satellite internet.</p>
      </header>
      <form method="post" action="#">
        <div className="row gtr-50">
          <div className="col-6 col-12-mobile">
            
          </div>
          <div className="col-6 col-12-mobile">
            
          </div>
          
          <div className="col-12">
            <ul className="actions">
             <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://goonet.netlify.app" className="btn btn-xl btn-light mr-4">
         GooNet..Browse Here !
        </a>
        
      </div>
       <Gallery
          images={ROW2_IMAGES.map(({ src, thumbnail, caption }) => ({
            src,
            thumbnail,
            caption,
          }))}
        />
    </section>

            </ul>
          </div>
        </div>
      </form>
    </article>

    <article className="container box style3">
      <header>
        <h2>Low latency = video calls & online gaming</h2>
        <p>Latency is the time it takes to send data from one point to the next.
         When satellites are far from Earth, latency is high, resulting in poor performance for activities like video calls and online gaming.</p>
        <br />
        Check it out
        <a href="https://srocket.netlify.app" className="btn btn-xl btn-light mr-4">
       Learn More
        </a>
      </header>
    </article>




    <Footer />
  </Layout>
);

export default IndexPage;









